__turbopack_context__.v({
  "container": "NSrzja_container",
  "description": "NSrzja_description",
  "hero-reveal": "NSrzja_hero-reveal",
  "project-image": "NSrzja_project-image",
  "subtitle": "NSrzja_subtitle",
  "text-content": "NSrzja_text-content",
});
